const incidentInterventions = (() => {
  let interventionTable, interventionData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Interventions
  //-------------------------------------------------------------------------------

  function getIncidentInterventionView() {
    const frag = document.createDocumentFragment();
    
    interventionTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Type'],
      endIcon: true,
    });

    const headers = interventionTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addInterventionBtnDiv = document.createElement('div');
    const addInterventionBtn = new Button({
      text: 'ADD NEW INTERVENTION',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(interventionTable);
    if ($.session.SetupInsert) {
      addInterventionBtn.button.style.float = 'right';
      addInterventionBtn.renderTo(addInterventionBtnDiv);
      frag.append(addInterventionBtnDiv);
    }

    const tableInterventionData = interventionData
      .map(p => {
        return {
          values: [p.interventionName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showInterventionPopup(p);
          },
          endIconCallback: () => handleInterventionDelete(p),
        };
      });

    table.populate(interventionTable, tableInterventionData);
    table.sortTableByHeader(interventionTable);

    addInterventionBtn.onClick(e => {
      showInterventionPopup();
    });

    return frag;
  }

  // Incident Interventions
  //-------------------------------------------------------------------------------

  function showInterventionPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const interventionForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Type',
          id: 'cName',
          required: true,
        },
      ],
    });

    interventionForm.onKeyup(() => {
      interventionForm.inputs['cName'].setValidtyError('');
      interventionForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(interventionForm);
    });
    interventionForm.onChange(event => {
      interventionForm.inputs['cName'].setValidtyError('');
      interventionForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(interventionForm);
    });

    interventionForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentInterventionData', {
          id: rowData ? rowData.interventionId : 0,
          interventionName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentInterventionDataResult;
      const newID = resp.interventionId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This intervention already exists.', interventionForm);
        interventionForm.buttons['submit'].toggleDisabled(true);
        interventionForm.buttons['cancel'].toggleDisabled(true);
      } else {
        interventionForm.clear();
        POPUP.hide(popup);
        await getInterventionData();
        updateInterventionTable();
      }
    });

    interventionForm.onCancel(event => {
      interventionForm.clear();
      interventionForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    interventionForm.renderTo(popup);

    POPUP.show(popup);

    interventionForm.populate({
      cName: rowData ? rowData.interventionName : '',
    });

    interventionForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      interventionForm.disableFormInputs();
    }
  }

  async function handleInterventionDelete(row) {
    const rowData = interventionData.find(a => a.interventionId == row.interventionId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This intervention type is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this intervention type?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentInterventionData', {
            token: $.session.Token,
            interventionId: row.interventionId,
          });

          await getInterventionData();
          updateInterventionTable();
        }
      });
    }
  }
  function updateInterventionTable() {
    const tableInterventionData = interventionData
      .map(p => {
        return {
          values: [p.interventionName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showInterventionPopup(p);
          },
          endIconCallback: () => handleInterventionDelete(p),
        };
      });

    table.populate(interventionTable, tableInterventionData);
  }

  async function getInterventionData() {
    const dataIntervention = await _UTIL.fetchData('getIncidentIntervention');
    interventionData = dataIntervention.getIncidentInterventionResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getInterventionData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Interventions';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Interventions') {
      viewMarkup = getIncidentInterventionView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
